// === utils =====================================================

function openCartDrawer() {
  document.getElementById('CartOverlay')?.classList.add('active');
  document.getElementById('CartDrawer')?.classList.add('active');
  document.getElementById('CartDrawer')?.setAttribute('aria-hidden', 'false');
}

function closeCartDrawer() {
  document.getElementById('CartOverlay')?.classList.remove('active');
  document.getElementById('CartDrawer')?.classList.remove('active');
  document.getElementById('CartDrawer')?.setAttribute('aria-hidden', 'true');
}

function moneyFormatFromCents(cents) {
  // Shopify renvoie les prix en cents. On fait de l'€ simple.
  // Si tu veux les vrais formats Shopify, tu peux demander un rendu du Liquid côté backend.
  const euros = cents / 100;
  return euros.toLocaleString('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  });
}

// met à jour l'interface du drawer suite à un /cart.js frais
function renderCartToDrawer(cartJSON) {
  const itemsWrap = document.getElementById('CartItems');
  const totalNode = document.getElementById('CartTotal');

  if (!itemsWrap || !totalNode) return;

  // Panier vide ?
  if (!cartJSON.items.length) {
    itemsWrap.innerHTML = `<p class="cart-empty-msg">Ton panier est vide.</p>`;
    totalNode.textContent = moneyFormatFromCents(cartJSON.total_price);
    return;
  }

  // Sinon on recrée toutes les lignes
  let html = '';
  cartJSON.items.forEach((item, idx) => {
    const lineIndex = idx + 1;
    html += `
      <div class="cart-line" data-line="${lineIndex}">
        <div class="cart-line-thumb">
          ${item.image ? `<img class="cart-line-img" src="${item.image}" alt="${item.product_title}">` : ''}
        </div>

        <div class="cart-line-info">
          <div class="cart-line-title">${item.product_title}</div>
          <div class="cart-line-variant">${item.variant_title || ''}</div>

          <div class="cart-line-qty">
            Qté :
            <button class="qty-btn" data-qty-minus data-line="${lineIndex}" type="button">−</button>
            <span class="qty-value" data-qty-val>${item.quantity}</span>
            <button class="qty-btn" data-qty-plus data-line="${lineIndex}" type="button">+</button>

            <button class="qty-remove" data-qty-remove data-line="${lineIndex}" type="button">Retirer</button>
          </div>

          <div class="cart-line-price">${moneyFormatFromCents(item.line_price)}</div>
        </div>
      </div>
    `;
  });

  itemsWrap.innerHTML = html;
  totalNode.textContent = moneyFormatFromCents(cartJSON.total_price);
}

// Récupère le /cart.js après modif et rafraîchit le drawer
function refreshDrawerFromCart() {
  return fetch('/cart.js', {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  })
    .then(r => r.json())
    .then(cart => {
      renderCartToDrawer(cart);
    });
}

// === Ajouter au panier sans reload ============================

function ajaxAddToCart(formEl) {
  const fd = new FormData(formEl);

  return fetch('/cart/add.js', {
    method: 'POST',
    body: fd,
    headers: { 'Accept': 'application/json' }
  })
  .then(r => r.json())
  .then(() => {
    // produit ajouté -> refresh drawer, puis ouvrir
    return refreshDrawerFromCart().then(() => {
      openCartDrawer();
    });
  })
  .catch(err => {
    console.error('Erreur add to cart', err);
    // fallback = redirect normal si souci
    formEl.submit();
  });
}

// === Changer quantité / retirer ===============================

function changeLineQty(line, newQty) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      line: line,
      quantity: newQty
    })
  })
  .then(r => r.json())
  .then(cart => {
    renderCartToDrawer(cart);
  });
}

// === Listener global ==========================================

document.addEventListener('DOMContentLoaded', () => {
  // 1. Ouvrir / fermer le drawer via clic overlay / X
  const overlay = document.getElementById('CartOverlay');
  const drawer = document.getElementById('CartDrawer');

  overlay?.addEventListener('click', closeCartDrawer);
  drawer?.querySelector('[data-cart-close]')?.addEventListener('click', closeCartDrawer);

  // 2. Intercepter tous les forms d'ajout au panier .product-form
  document.querySelectorAll('form.product-form').forEach(formEl => {
    formEl.addEventListener('submit', (e) => {
      e.preventDefault();
      ajaxAddToCart(formEl);
    });
  });

  // 3. Délégation d'événements pour + / − / Retirer dans le drawer
  drawer?.addEventListener('click', (e) => {
    const minusBtn = e.target.closest('[data-qty-minus]');
    const plusBtn  = e.target.closest('[data-qty-plus]');
    const removeBtn= e.target.closest('[data-qty-remove]');

    if (minusBtn) {
      const line = minusBtn.getAttribute('data-line');
      const lineEl = drawer.querySelector(`.cart-line[data-line="${line}"]`);
      const qtyValNode = lineEl?.querySelector('[data-qty-val]');
      const current = qtyValNode ? parseInt(qtyValNode.textContent, 10) : 1;
      const next = Math.max(current - 1, 0); // 0 => supprime
      changeLineQty(line, next);
      return;
    }

    if (plusBtn) {
      const line = plusBtn.getAttribute('data-line');
      const lineEl = drawer.querySelector(`.cart-line[data-line="${line}"]`);
      const qtyValNode = lineEl?.querySelector('[data-qty-val]');
      const current = qtyValNode ? parseInt(qtyValNode.textContent, 10) : 1;
      const next = current + 1;
      changeLineQty(line, next);
      return;
    }

    if (removeBtn) {
      const line = removeBtn.getAttribute('data-line');
      changeLineQty(line, 0); // 0 = supprime l’item
      return;
    }
  });

  // 4. Bouton "VOIR LE PANIER COMPLET"
  const goCartBtn = drawer?.querySelector('[data-go-cart]');
  goCartBtn?.addEventListener('click', () => {
    // on force l'URL du vrai panier
    window.location.href = (window.SH4DE_ROOT || '/') + 'cart';
  });

  // 5. Bouton "PROCÉDER AU PAIEMENT"
  const goCheckoutBtn = drawer?.querySelector('[data-go-checkout]');
  goCheckoutBtn?.addEventListener('click', () => {
    // on force l'URL du vrai checkout
    window.location.href = (window.SH4DE_ROOT || '/') + 'checkout';
  });
});

